export const questions = [
  {
    id: "Q1",
    text: {
      en: "You have been asked to help a team that has had a lot of turnover and needed to realign on their goals. The company is a big Vietnamese company that imports products from China and sells them on the Vietnamese market. The team is in Finance. How do you start your preparation?",
      vn: "Bạn được mời hỗ trợ một nhóm Tài chính tại một công ty Việt Nam lớn nhập hàng từ Trung Quốc. Nhóm đã có nhiều thay đổi nhân sự và cần thống nhất lại mục tiêu. Bạn bắt đầu chuẩn bị như thế nào?"
    },
    options: {
      A: {
        en: "Meet with the manager to understand what they want out of the day.",
        vn: "Gặp người quản lý để hiểu họ mong đợi điều gì từ buổi làm việc."
      },
      B: {
        en: "Choose a proven workshop format that worked for similar cases.",
        vn: "Chọn một định dạng workshop đã hiệu quả trong các trường hợp tương tự."
      },
      C: {
        en: "Interview the manager and 2 team members to learn their perspectives.",
        vn: "Phỏng vấn quản lý và 2 thành viên để tìm hiểu quan điểm của họ."
      },
      D: {
        en: "Ask HR what the root problem is so you can plan the session.",
        vn: "Hỏi bộ phận Nhân sự về vấn đề cốt lõi để bạn có thể lập kế hoạch."
      }
    }
  },
  {
    id: "Q2",
    text: {
      en: 'The manager says, "Can you make sure everyone gets along better by the end?" What’s your next step?',
      vn: 'Quản lý nói: "Bạn có thể giúp mọi người hòa thuận hơn sau buổi này không?" Bạn làm gì tiếp theo?'
    },
    options: {
      A: {
        en: "Agree and design the session around building better relationships.",
        vn: "Đồng ý và thiết kế buổi làm việc xoay quanh việc xây dựng mối quan hệ tốt hơn."
      },
      B: {
        en: "Ask them what 'getting along better' would look like in practice.",
        vn: "Hỏi họ 'hòa thuận hơn' nghĩa là gì cụ thể trong công việc."
      },
      C: {
        en: "Suggest a team building game to warm up at the beginning.",
        vn: "Đề xuất một trò chơi gắn kết nhóm để khởi động đầu buổi."
      },
      D: {
        en: "Say that’s not your job; you’re here to run the process.",
        vn: "Nói rằng đó không phải việc của bạn; bạn chỉ điều phối quá trình."
      }
    }
  },
  {
    id: "Q3",
    text: {
      en: "The team enters the room. There’s tension. Some people are joking loudly, while others look withdrawn. What's your first move?",
      vn: "Cả nhóm bước vào phòng. Không khí căng thẳng. Một số người nói đùa ầm ĩ, vài người khác im lặng rút lui. Bạn làm gì đầu tiên?"
    },
    options: {
      A: {
        en: "Start with a check-in and ask everyone how they’re arriving.",
        vn: "Bắt đầu bằng một vòng chia sẻ cảm nhận khi đến buổi làm việc."
      },
      B: {
        en: "Ignore the mood and jump straight into the agenda.",
        vn: "Bỏ qua không khí và bắt đầu chương trình luôn."
      },
      C: {
        en: "Ask the manager to say a few words to the group.",
        vn: "Mời người quản lý phát biểu với cả nhóm."
      },
      D: {
        en: "Wait until everyone settles, then start silently.",
        vn: "Chờ mọi người ổn định rồi bắt đầu một cách im lặng."
      }
    }
  },
  // I will continue the full list of Q4–Q11 next to avoid cutting off. Ready?
  {
    id: "Q4",
    text: {
      en: "You ask, “What’s our shared goal today?” People give vague or conflicting answers. How do you proceed?",
      vn: "Bạn hỏi: “Mục tiêu chung hôm nay của chúng ta là gì?” Mọi người trả lời mơ hồ hoặc không đồng nhất. Bạn xử lý thế nào?"
    },
    options: {
      A: {
        en: "Write all answers on a flipchart and move on to the next part.",
        vn: "Viết tất cả các câu trả lời lên bảng và chuyển sang phần tiếp theo."
      },
      B: {
        en: "Ask follow-up questions to narrow it down to something concrete.",
        vn: "Hỏi thêm để thu hẹp lại thành một mục tiêu cụ thể."
      },
      C: {
        en: "Invite a small group to propose a summary goal for the team.",
        vn: "Mời một nhóm nhỏ đề xuất một mục tiêu chung cho cả đội."
      },
      D: {
        en: "Suggest a pre-defined goal to help them move forward.",
        vn: "Đề xuất một mục tiêu bạn chuẩn bị trước để giúp họ tiến lên."
      }
    }
  },
  {
    id: "Q5",
    text: {
      en: "During a discussion, one participant dominates while others stay quiet. What's your intervention strategy?",
      vn: "Trong cuộc thảo luận, một người chiếm sóng, những người khác im lặng. Bạn can thiệp thế nào?"
    },
    options: {
      A: {
        en: "Let it play out to avoid embarrassment.",
        vn: "Để mọi việc diễn ra tự nhiên để tránh mất mặt ai đó."
      },
      B: {
        en: "Pause and ask those who haven’t spoken to share their view.",
        vn: "Tạm dừng và mời những người chưa nói nêu ý kiến."
      },
      C: {
        en: "Acknowledge the dominant speaker and ask them to summarize.",
        vn: "Cảm ơn người nói nhiều và mời họ tóm tắt lại ý chính."
      },
      D: {
        en: "Privately ask the dominant person to hold back.",
        vn: "Trao đổi riêng với người đó để họ kiềm chế lại."
      }
    }
  },
  {
    id: "Q6",
    text: {
      en: "One participant rolls their eyes and sighs loudly after another’s comment. What do you do?",
      vn: "Một người lật mắt và thở dài sau khi người khác nói. Bạn làm gì?"
    },
    options: {
      A: {
        en: "Say nothing — this happens in every team.",
        vn: "Không nói gì — chuyện này nhóm nào cũng có."
      },
      B: {
        en: "Pause and name the behavior in a neutral tone.",
        vn: "Tạm dừng và nêu hành vi một cách trung lập."
      },
      C: {
        en: "Ask the person what they meant by that reaction.",
        vn: "Hỏi người đó xem họ muốn thể hiện điều gì qua hành động đó."
      },
      D: {
        en: "Make a joke to lighten the tension.",
        vn: "Pha trò để xua tan không khí căng thẳng."
      }
    }
  },
  {
    id: "Q7",
    text: {
      en: "Time is running out, and the team still has not agreed on next steps. What do you prioritize now?",
      vn: "Gần hết giờ mà nhóm vẫn chưa thống nhất bước tiếp theo. Bạn ưu tiên điều gì?"
    },
    options: {
      A: {
        en: "Ask each person to write down their next step individually.",
        vn: "Mời từng người viết bước tiếp theo riêng của họ."
      },
      B: {
        en: "Let the manager take over and decide.",
        vn: "Để người quản lý quyết định luôn."
      },
      C: {
        en: "Summarize what’s been said and ask the group to decide.",
        vn: "Tóm tắt ý đã có và mời nhóm quyết định."
      },
      D: {
        en: "Acknowledge the lack of agreement and end on time.",
        vn: "Ghi nhận sự chưa thống nhất và kết thúc đúng giờ."
      }
    }
  },
  {
    id: "Q8",
    text: {
      en: 'The team has listed several surface-level problems (e.g., “too many meetings”, “unclear emails”), but seems stuck. What’s your move to go deeper?',
      vn: 'Nhóm liệt kê một số vấn đề bề mặt (“họp quá nhiều”, “email không rõ”), nhưng có vẻ bị kẹt lại. Bạn làm gì để đi sâu hơn?'
    },
    options: {
      A: {
        en: "Ask them to rank the problems in order of urgency.",
        vn: "Yêu cầu họ xếp hạng mức độ khẩn cấp của các vấn đề."
      },
      B: {
        en: "Invite them to name the root causes they see behind the issues.",
        vn: "Mời họ nêu nguyên nhân gốc rễ đằng sau các vấn đề đó."
      },
      C: {
        en: "Assign each group one problem to analyze further.",
        vn: "Chia nhóm để mỗi nhóm phân tích một vấn đề."
      },
      D: {
        en: "Switch to a lighter topic to reset energy.",
        vn: "Chuyển sang chủ đề nhẹ hơn để làm mới tinh thần."
      }
    }
  },
  {
    id: "Q9",
    text: {
      en: "After lunch, the group is low energy and disengaged. What do you do?",
      vn: "Sau giờ ăn trưa, nhóm thiếu năng lượng và không tập trung. Bạn làm gì?"
    },
    options: {
      A: {
        en: "Invite a quick energizer to reset the group.",
        vn: "Mời cả nhóm tham gia một trò khởi động ngắn."
      },
      B: {
        en: "Ignore it and push ahead with the session.",
        vn: "Bỏ qua và tiếp tục chương trình."
      },
      C: {
        en: "Ask for a 5-minute movement or coffee break.",
        vn: "Cho cả nhóm nghỉ 5 phút để đứng dậy hoặc uống cà phê."
      },
      D: {
        en: "Ask the group why they seem unmotivated.",
        vn: "Hỏi cả nhóm lý do họ có vẻ thiếu động lực."
      }
    }
  },
  {
    id: "Q10",
    text: {
      en: "Two participants begin disagreeing sharply about who’s responsible for a recent failure. Others are watching silently. How do you respond?",
      vn: "Hai người tranh cãi gay gắt về việc ai chịu trách nhiệm cho một thất bại gần đây. Những người khác im lặng quan sát. Bạn xử lý thế nào?"
    },
    options: {
      A: {
        en: "Let them finish, then invite others to share their thoughts.",
        vn: "Để họ nói xong rồi mời những người khác chia sẻ."
      },
      B: {
        en: "Ask both to name what they need from the group to move forward.",
        vn: "Hỏi cả hai họ cần gì từ nhóm để tiếp tục."
      },
      C: {
        en: "Suggest parking the issue and revisiting it later.",
        vn: "Đề xuất tạm gác vấn đề và sẽ quay lại sau."
      },
      D: {
        en: "Pause and name the dynamic that’s playing out.",
        vn: "Tạm dừng và nêu rõ tình huống đang xảy ra."
      }
    }
  },
  {
    id: "Q11",
    text: {
      en: "How do you decide which materials to use during the session?",
      vn: "Bạn quyết định sử dụng tài liệu hỗ trợ như thế nào trong buổi làm việc?"
    },
    options: {
      A: {
        en: "I bring post-its, markers, and props to adapt to what emerges.",
        vn: "Tôi mang theo giấy note, bút lông, đạo cụ để linh hoạt xử lý tình huống."
      },
      B: {
        en: "I prepare a kit that fits the session structure I planned.",
        vn: "Tôi chuẩn bị bộ công cụ phù hợp với chương trình đã lên kế hoạch."
      },
      C: {
        en: "I only use flipcharts or slides if requested.",
        vn: "Tôi chỉ dùng bảng hoặc slide nếu có yêu cầu."
      },
      D: {
        en: "Materials are not that important. I focus on people.",
        vn: "Tài liệu không quan trọng lắm. Tôi tập trung vào con người."
      }
    }
  }
];
